export default "__VITE_ASSET__BdeujEdh__"